<template>
    <div class="container-connexion">
        <Accueil @connecter="connecter" />
    </div>
</template>

<style>
    .container-connexion{
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: center;
    }
</style>

<script>
    import { defineComponent } from 'vue';
    import Accueil from './Accueil.vue';
    import Loader from './Loader.vue';

    import config from "../config.js";
    export default defineComponent({
        components: {
            //Les composants
            Accueil,
            Loader
        },
        data: function () {
            return {
                message: 'Hello world',
                isLoading: false,
            }
        },

        computed: {

        },

        methods: {
            async waitLoading() {
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false;
                }, 30000)
            },
            connecter(obj) {
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false;
                    this.$store.dispatch("ConnexionStore/connecter", obj);
                }, 2000)
                return this.$store.getters["ConnexionStore/getConnexionValeur"];
            },
            test() {
                fetch(config.urlBackEnd + "Patient/GetTest?nb=41&str=%285")
                    .then(response => { return response.json() })
                    .then(data => { data.val= "val"; console.log(data) });
            }
        },
        props: {

        }
    });
</script>
